<template>
  <div>
    <v-card-title>
      <h2>Bulk Messaging</h2>
      <v-spacer/>
      <v-btn
        dark
        color="blue"
        round
        @click="editMessage({send_email: true, send_sms: true, send_push: true})">
        <v-icon
          dark
          left
        >
          add
        </v-icon>
        New Message
      </v-btn>
    </v-card-title>
    <br />
    <v-alert
      v-if="isLegacyDomain() || isNewDomain()"
      :value="true"
      type="alert"
      icon="mdi-bullhorn"
      style="background: #FFEB3B;color:black;"
    >
      All contact login and email links now come from {{ getDomainInfo.subdomain }}.caselocker.com. Please update your communications accordingly.
    </v-alert>
    <v-alert
      :value="true"
      type="info"
    >
      <b>{{ app_name }} will not send messages to users that are disabled or do not have an e-mail on file</b>. The estimated number shown is all users {{ app_name }} can send messages to.
    </v-alert>
    <v-layout
      row wrap
    >
      <v-flex
        md12
      >
        <v-card>
          <v-data-table
            :items="messages"
            :pagination.sync="pagination"
            :total-items="totalMessages"
            :rows-per-page-items="paginationStrings"
            :headers="headers"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td colspan="5">
                  <div style="text-align:center;padding:25px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                :key="props.item.id"
              >
                <td>
                  <div
                    style="display:flex;"
                  >
                    <v-icon
                      v-if="props.item.certified"
                      size="24"
                      style="padding-right: 5px;"
                    >
                      mdi-seal-variant
                    </v-icon>
                    <div>
                      {{props.item.subject}}
                    </div>
                  </div>
                </td>
                <td
                  style="padding: 5px;line-height:24px;"
                >
                  <span v-html="filterString(props.item)">
                  </span>
                </td>
                <td>
                  <span>{{ convertToLocal(props.item.created_at) }}<br /><small>{{props.item.created_by_name || 'System'}}</small></span>
                </td>
                <td>
                  <span>{{ convertToLocal(props.item.updated_at) }}<br /><small>{{props.item.updated_by_name || 'System'}}</small></span>
                </td>
                <td style="text-transform: capitalize;">
                  <span v-html="statusString(props.item)">
                  </span>
                </td>
                <td style="text-transform: capitalize;">
                  <v-btn
                    v-if="props.item.status !== 'draft'"
                    flat
                    small
                    fab
                    @click="duplicateMessage(props.item)"
                  >
                    <v-icon>
                      mdi-content-duplicate
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="props.item.status !== 'draft' && props.item.certified"
                    flat
                    small
                    fab
                    :to="{ name: 'ContactMessageSearch', query: { filter: JSON.stringify({'bulkop': props.item.id}) } }"
                  >
                    <v-icon>
                      mdi-filter
                    </v-icon>
                  </v-btn>
                  <div
                    v-if="props.item.status === 'draft'"
                  >
                    <v-btn
                      flat
                      small
                      fab
                      @click="deleteMessageDialog(props.item)"
                    >
                      <v-icon>
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      small
                      fab
                      @click="editMessage(props.item)"
                    >
                      <v-icon>
                        edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      color="primary"
                      fab
                      @click="presend(props.item)"
                    >
                      <v-icon
                        color="white"
                      >
                        send
                      </v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-fade-transition>
      <div
        v-if="editDraft || sendMessage"
        class="v-overlay v-overlay--active"
        style="z-index: 201;"
      ></div>
    </v-fade-transition>
    <v-dialog
      v-model="editDraft"
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      content-class="right-held"
      :hide-overlay="false"
    >
      <v-card>
        <v-toolbar
          class="primary-color"
          dark
          flat
        >
          Edit Message
        </v-toolbar>
        <v-card-text
          v-if="editDraft"
        >
          <v-text-field
            v-model="editingDraft.subject"
            solo
            label="Subject"
          />
          <v-layout
            row
            grid
          >
            <v-flex
              xs6
              style="padding: 0px 5px 0px 0px;"
            >
              <v-autocomplete
                v-model.trim="filterTags"
                :items="tagResults"
                :search-input.sync="tagSearch"
                label="Send to Contacts with Tags"
                small-chips
                item-text="tag"
                item-value="tag"
                solo
                multiple
                deletable-chips
                cache-items
                auto-select-first
                hide-selected
                @input="tagSearch = ''"
              />
            </v-flex>
            <v-flex
              xs6
              style="padding: 0px 5px 0px 0px;"
            >
              <v-text-field
                v-model="editingDraft.reply_to"
                :rules="editingDraft.reply_to ? [v => /.+@.+/.test(v) || 'E-mail must be valid'] : []"
                label="Reply To E-mail"
                solo
                hint="Specify an e-mail inbox contacts can reply to"
              />
            </v-flex>
          </v-layout>
          <v-autocomplete
            v-model="newFormCasetype"
            :loading="searchingCasetypes"
            :items="casetypes"
            :search-input.sync="searchCasetypes"
            item-value="id"
            item-text="name"
            label="Send to Contacts with Casetype"
            solo
            auto-select-first
            dense
          />
          <v-autocomplete
            v-model="newFormTemplate"
            :loading="searching"
            :items="formTemplates"
            :search-input.sync="searchTemplates"
            item-value="id"
            item-text="name"
            label="Send to Contacts with Form Template"
            solo
            auto-select-first
            dense
          >
            <template slot="no-data">
              <v-list-tile>
                <v-list-tile-title v-if="!searching && !searchTemplates">
                  Type at least
                  <strong>3</strong>
                  characters to begin searching
                </v-list-tile-title>
                <v-list-tile-title v-if="!searching && searchTemplates">
                  No results for <i>{{searchTemplates}}</i>. Refine your search and try again.
                </v-list-tile-title>
                <v-list-tile-title v-if="searching">
                  <b><v-icon small>search</v-icon>Searching...</b>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </v-autocomplete>
          <v-expand-transition>
            <v-layout
              v-if="newFormTemplate"
              row
              grid
            >
              <v-flex
                xs6
                style="padding: 0px 5px 0px 0px;"
              >
                <v-autocomplete
                  v-model="filterFormTags"
                  :items="formTagResults"
                  :search-input.sync="formTagSearch"
                  item-text="tag"
                  item-value="tag"
                  small-chips
                  multiple
                  solo
                  deletable-chips
                  auto-select-first
                  cache-items
                  hide-selected
                  @input="formTagSearch = ''"
                  :label="`Filter Form Query by Tags`"
                />
              </v-flex>
              <v-flex
                xs6
                style="padding: 0px 0px 0px 5px;"
              >
                <v-autocomplete
                  v-model="searchStatus"
                  :items="statusStrings"
                  item-text="name"
                  item-value="value"
                  small-chips
                  multiple
                  solo
                  deletable-chips
                  auto-select-first
                  hide-selected
                  :label="`Filter Form Query by Status`"
                />
              </v-flex>
            </v-layout>
          </v-expand-transition>
          <v-alert
            :value="true"
            type="warning"
            outline
          >
            Tag filtering is an <b>or</b> query, meaning any contact or form with the matching tags will be selected.
          </v-alert>
          <br />
          <span>Message Contents:</span>
          <Editor
            v-if="editDraft"
            ref="htmlEditor"
            :html="editingDraft.message"
            :placeholders="placeholders"
          />
          <div
            v-if="domainInfo.text_enabled"
          >
            <b>Messages over 300 characters will be truncated for text notifications</b>
          </div>
          <div>
            <v-switch
              v-model="editingDraft.certified"
              label="Certified Message"
              :hint="`Require Contacts to log in to ${app_name} to view the message, and track when they read it.`"
              persistent-hint
            ></v-switch>
          </div>
          <div>
            <div
              style="font-size: 16px;font-weight: 700;margin-top: 20px;"
            >
              Message Channels<br />
              <small>{{ app_name }} will attempt to send via the selected channels, if the Contact has that channel enabled.</small>
            </div>
            <div
              style="display: flex;flex-direction: row;flex-wrap: wrap;"
            >
              <v-checkbox
                v-model="editingDraft.send_email"
                label="E-mail"
                class="channel-switch"
              />
              <v-checkbox
                v-model="editingDraft.send_sms"
                label="SMS"
                class="channel-switch"
              />
              <v-checkbox
                v-model="editingDraft.send_push"
                label="Push Notification"
                class="channel-switch"
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions
          style="margin-right:10px;"
        >
          <v-spacer />
          <v-btn
            color="black"
            flat
            @click="editDraft = false"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="saving"
            class="primary-color"
            dark
            @click="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="sendMessage"
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      content-class="right-held"
      :hide-overlay="false"
    >
      <v-card
        v-if="sendMessageObj"
      >
        <v-toolbar
          class="primary"
          dark
          flat
        >
          <v-icon
            style="margin-right:30px;"
          >
            send
          </v-icon>
          Confirm Message Delivery
        </v-toolbar>
        <v-card-text
          v-if="sendMessage"
        >
          <h3>Please confirm this message prior to sending.</h3>
          <span>
            This message will send to approx. {{sendMessageObj.estimated_recipient_count}} contacts. This number may change if contacts are added or removed from the tags.
          </span>
          <br />
          <br />
          <v-text-field
            v-model="sendMessageObj.subject"
            disabled
            label="Subject"
          />
          <v-layout
            row
            grid
          >
            <v-flex
              xs6
              style="padding: 0px 5px 0px 0px;"
            >
              <v-autocomplete
                v-model="sendMessageObj.tags"
                :items="sendMessageObj.tags"
                :search-input.sync="tagSearch"
                label="Send to Contacts with Tags"
                small-chips
                disabled
                multiple
                deletable-chips
                cache-items
                auto-select-first
                hide-selected
                @input="tagSearch = ''"
              />
            </v-flex>
            <v-flex
              xs6
              style="padding: 0px 5px 0px 0px;"
            >
              <v-text-field
                v-model="sendMessageObj.reply_to"
                label="Reply To E-mail"
                disabled
                hint="Specify an e-mail inbox contacts can reply to"
              />
            </v-flex>
          </v-layout>
          <v-autocomplete
            v-if="sendMessageObj.casetype"
            v-model="searchCasetypes"
            :items="[`${searchCasetypes}`]"
            label="Send to Contacts with Casetype"
            disabled
          />
          <v-autocomplete
            v-model="sendMessageObj.template"
            :loading="searching"
            :items="formTemplates"
            :search-input.sync="searchTemplates"
            item-value="id"
            item-text="name"
            label="Send to Contacts with Form Template"
            disabled
            dense
          />
          <v-layout
            v-if="sendMessageObj.template"
            row
            grid
          >
            <v-flex
              xs6
              style="padding: 0px 5px 0px 0px;"
            >
              <v-autocomplete
                :value="JSON.parse(sendMessageObj.form_tags)"
                :items="JSON.parse(sendMessageObj.form_tags)"
                item-text="name"
                item-value="value"
                small-chips
                multiple
                disabled
                hide-selected
                :label="`Filter Form Query by Tags`"
              />
            </v-flex>
            <v-flex
              xs6
              style="padding: 0px 0px 0px 5px;"
            >
              <v-autocomplete
                :value="JSON.parse(sendMessageObj.statuses)"
                :items="JSON.parse(sendMessageObj.statuses)"
                item-text="name"
                item-value="value"
                small-chips
                multiple
                disabled
                :label="`Filter Form Query by Status`"
              />
            </v-flex>
          </v-layout>
          <div
            style="padding:15px;border: 1px solid lightgrey;background:white;"
            v-html="parsePlaceholder(sendMessageObj.message, placeholders)"
          >
          </div>
          <div
            v-if="sendMessageObj.certified"
            style="display:flex;padding: 5px;background: rgba(0,0,0,0.05);border-radius: 15px;border: 2px solid rgba(0,0,0,0.2);margin-bottom: 10px;margin-top: 15px;"
          >
              <div>
                  <v-icon
                      size="48"
                  >
                      mdi-seal-variant
                  </v-icon>
              </div>
              <div>
                  <div
                      style="font-size: 18px;font-weight: 700;"
                  >
                      Certified Message
                  </div>
                  <div>
                      This message is will send <b>Certified</b>. The subject and message body will be hidden until the Contact explicitly opens the message, and notifications will only notify the Contact of an important message available in their {{ app_name }} account.
                  </div>
              </div>
          </div>
          <div>
            <div
              style="font-size: 16px;font-weight: 700;margin-top: 20px;"
            >
              Message Channels<br />
              <small>{{ app_name }} will attempt to send via the selected channels, if the Contact has that channel enabled.</small>
            </div>
            <div
              style="display: flex;flex-direction: row;flex-wrap: wrap;"
            >
              <v-checkbox
                v-model="sendMessageObj.send_email"
                disabled
                label="E-mail"
                class="channel-switch"
              />
              <v-checkbox
                v-model="sendMessageObj.send_sms"
                disabled
                label="SMS"
                class="channel-switch"
              />
              <v-checkbox
                v-model="sendMessageObj.send_push"
                disabled
                label="Push Notification"
                class="channel-switch"
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions
          style="margin-right:10px;"
        >
          <v-spacer />
          <v-btn
            color="black"
            flat
            @click="sendMessage = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="grey"
            dark
            @click="editMessage(sendMessageObj);sendMessage = false"
          >
            Back to Editing
          </v-btn>
          <v-btn
            :disabled="sending"
            class="primary"
            dark
            @click="send()"
          >
            Confirm &amp; Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="limit_text"
      persistent
      width="400"
    >
      <v-card>
        <v-card-text>
          <b>Warning</b>: Your message is over 300 characters. The text notification will be truncated.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="limit_text = false"
          >
            Go Back
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="send();limit_text = false"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      persistent
      width="400"
    >
      <v-card>
        <v-card-text>
          Deleting draft '{{editingDraft.subject}}'. This action can not be reversed.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="deleteDialog = false;editingDraft = []"
          >
            Go Back
          </v-btn>
          <v-btn
            color="red"
            dark
            @click="deleteMessage()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'
import Editor from '@/components/admin/Editor'
import GlobalConstants from '@/globals'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactMassMessaging',
  components: {
    Editor,
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      messages: [],
      editDraft: false,
      editingDraft: {},
      sendMessage: false,
      sendMessageObj: {},
      deleteDialog: false,
      pagination: {
        page: this.$route.query.page || 1,
        descending: this.$route.query.descending || false,
        rowsPerPage: this.$route.query.rowsPerPage || 10,
        sortBy: this.$route.query.sortBy || null
      },
      headers: [
        { text: 'Subject', value: 'name', width: 250 },
        { text: 'Sending To', value: 'filters', width: 300, sortable: false },
        { text: 'Created', value: 'created_at', width: 175 },
        { text: 'Last Updated', value: 'updated_at', width: 175 },
        { text: 'Status', sortable: false, width:200 },
        { text: '', value: '', width: 250, sortable: false }
      ],
      defaultPagination: {
        page: 1,
        descending: false,
        rowsPerPage: 10,
        sortBy: null
      },
      loading: true,
      paginationStrings: [
        10, 25, 50
      ],
      filterTags: [],
      filterFormTags: [],
      tagSearch: null,
      tagResults: [],
      formTagResults: [],
      formTemplates: [],
      searching: false,
      searchTemplates: '',
      newFormTemplate: '',
      statusStrings: GlobalConstants.StatusStrings,
      searchStatus: '',
      formTagSearch: '',
      limit_text: false,
      domainInfo: {},
      saving: false,
      sending: false,
      placeholders: [
        {
          scope: "contact",
          variable: "first_name",
          name: "Contact: First Name",
        },
        {
          scope: "contact",
          variable: "middle_name",
          name: "Contact: Middle Name",
        },
        {
          scope: "contact",
          variable: "last_name",
          name: "Contact: Last Name"
        },
        {
          scope: "contact",
          variable: "full_name",
          name: "Contact: Full Name (Last, Middle First)"
        },
        {
          scope: "contact",
          variable: "cuid",
          name: "Contact: CUID"
        },
        {
          scope: "contact",
          variable: "email",
          name: "Contact: Email"
        },
        {
          scope: "contact",
          variable: "phone",
          name: "Contact: Phone"
        }
      ],
      searchCasetypes: '',
      newFormCasetype: '',
      searchingCasetypes: false,
      casetypes: []
    }
  },
  created () {
    this.documentTitle('Bulk Messaging')
    this.domainInfo = this.getDomainInfo
  },
  watch: {
    tagSearch () {
      if (this.tagSearch) {
        this.fetchTags()
      }
    },
    formTagSearch () {
      if (this.formTagSearch) {
        this.fetchFormTags()
      }
    },
    searchTemplates () {
      if (this.searchTemplates) {
        this.loadFormTemplates()
      }
    },
    searchCasetypes () {
      if (this.searchCasetypes) {
        this.fetchCasetypes()
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getDomainInfo',
    ]),
    totalMessages () {
      return this.pagination.totalItems
    }
  },
  methods: {
    presend (item) {
      this.sendMessage = true
      this.sendMessageObj = item
      this.loadFormTemplates(item.template)
      if(item.casetype){
        this.loadCaseType(item.casetype)
      }
    },
    fetch () {
      this.loading = true
      api.bulkmail.bulkmail.list({
        search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage
      })
        .then(data => {
          this.messages = data.results
          this.pagination.totalItems = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
        })
    },
    save () {
      this.saving = true
      this.editingDraft.tags = this.filterTags
      this.editingDraft.template = this.newFormTemplate
      this.editingDraft.statuses = this.searchStatus ? JSON.stringify(this.searchStatus) : null
      this.editingDraft.message = this.$refs.htmlEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      this.editingDraft.form_tags = JSON.stringify(this.filterFormTags)
      this.editingDraft.casetype = this.newFormCasetype
      api.bulkmail.bulkmail.save(this.editingDraft)
        .then(data => {    
          this.saving = false
          this.loading = true
          this.editDraft = false
          this.loading = false
          this.fetch()
        })      
    },
    send () {
      this.sending = true
      this.loading = true
      var temp = this.sendMessageObj.message
      if (temp.replace( /(<([^>]+)>)/ig, '').length > 300 && !this.limit_text && this.getDomainInfo.text_enabled) {
        this.limit_text = true
      } else {
        api.bulkmail.bulkmail.send(this.sendMessageObj)
          .then(data => {
            this.sending = false
            this.sendMessage = false
            this.loading = false
            this.fetch()
          })
      }
    },
    fetchTags () {
      api.userform.contactTags.get(this.tagSearch)
        .then(tagResults => {
          this.tagResults = tagResults
        })
    },
    fetchFormTags () {
      api.userform.userformTags.get(this.formTagSearch)
        .then(tagResults => {
          this.formTagResults = tagResults
        })
    },
    filterString (filter) {
      var string = ""
      try {
        string = `Sending to approx. <span class="attention">${filter.estimated_recipient_count}</span> contacts`
        if (filter.tags && filter.tags.length > 0) {
          string += `<br /><b>Tag(s):</b> `
          filter.tags.forEach((tag, index) => {
            string += "<span class='attention'>"
            string += tag
            string += "</span>"
          })
        }
        if (filter.template) {
          string += `<br /><b>Template:</b> `
          string += "<span class='attention'>"
          string += filter.template_name
          string += "</span>"
        }
        if (filter.statuses) {
          var statuses = JSON.parse(filter.statuses)
          if (statuses.length > 0) {
            string += `<br /><b>Form Status:</b>`
            statuses.forEach((status) => {
              string += "<span class='attention'>"
              string += status
              string += "</span>"
            })
          }
        }
        if (filter.form_tags) {
          var tags = JSON.parse(filter.form_tags)
          if (tags.length > 0) {
            string += `<br /><b>Form Tags:</b>`
            tags.forEach((tags) => {
              string += "<span class='attention'>"
              string += tags
              string += "</span>"
            })
          }
        }
        if (filter.casetype){
          string += `<br /><b>Casetype:</b>`
          string += "<span class='attention'>"
          string += filter.casetype_name
          string += "</span>"
        }
        return string
      } catch (err) {
        return "Invalid Filter Conditions"
      }
    },
    statusString (message) {
      if (message.status === "sent") {
        return `Sent to <b>${message.recipient_count}</b> Contact${message.recipient_count > 1 ? 's' : ''}`
      } else {
        return message.status
      }
    },
    editMessage (message) {
      this.editDraft = true
      this.editingDraft = message
      this.tagResults = message.tags || []
      this.filterTags = message.tags || []
      this.searchStatus = message.statuses ? JSON.parse(message.statuses) : ''
      this.formTagResults =  message.form_tags ? JSON.parse(message.form_tags) : []
      this.filterFormTags = message.form_tags ? JSON.parse(message.form_tags) : []
      if (message.template) {
        this.searchTemplates = message.template
        this.loadFormTemplates(message.template)
        this.newFormTemplate = message.template
      } else {
        this.searchTemplates = ''
        this.newFormTemplate = ''
      }
      if (message.casetype) {
        this.loadCaseType(message.casetype)
      } else {
        this.searchCasetypes = ''
      }
    },
    deleteMessageDialog (message) {
      this.editingDraft = message
      this.deleteDialog = true
    },
    deleteMessage () {
      this.loading = true
      api.bulkmail.bulkmail.delete(this.editingDraft.id)
        .then(data => {
          this.loading = false
          this.deleteDialog = false
          this.fetch()
        })
    },
    duplicateMessage (duplicate) {
      var message = JSON.parse(JSON.stringify(duplicate))
      delete(message.id)
      this.editDraft = true
      this.editingDraft = message
      this.tagResults = message.tags || []
      this.filterTags = message.tags || []
      this.searchStatus = message.statuses ? JSON.parse(message.statuses) : ''
      this.formTagResults =  message.form_tags ? JSON.parse(message.form_tags) : []
      this.filterFormTags = message.form_tags ? JSON.parse(message.form_tags) : []
      if (message.casetype) {
        this.loadCaseType(message.casetype)
      } 
      if (message.template) {
        this.searchTemplates = message.template
        this.loadFormTemplates(message.template)
        this.newFormTemplate = message.template
      } else {
        this.searchTemplates = ''
        this.newFormTemplate = ''
      }
    },
    loadFormTemplates (searchById) {
      this.searching = true
      if (searchById) {
        var search = api.formtemplate.formtemplate.list({ filter: {id: searchById}, count: 15 })
      } else {
        var search = api.formtemplate.formtemplate.list({ search: this.searchTemplates, count: 15 })
      }
      search
        .then(data => {
          this.searching = false
          this.formTemplates = data.results
        })
    },
    fetchCasetypes () {
      this.searchingCasetypes = true
      api.cases.casetype.list({ search: this.searchCasetypes, count: 15 })
        .then(data => {
          this.searchingCasetypes = false
          this.casetypes = data.results
        })
    },
    loadCaseType (searchById) {
      this.searching = true
      api.cases.casetype.get(searchById)
        .then(data => {
          this.searching = false
          this.newFormCasetype = data.id
          this.searchCasetypes = data.name
        })
    }
  }
}
</script>

<style scoped>

table {
  table-layout: fixed;
  margin-top: 1em;
}

.editor__content .ProseMirror {
  min-height: 450px;
}


.channel-switch {
  margin-top: 0 !important;
}
</style>
